<template>
  <div v-if="isPC" class="bottom">
    <div class="footer-item">
      <p>主办单位: 上海市教育委员会</p>
      <p>Organizers: Shanghai Municipal Education Commission</p>
    </div>
    <div class="footer-item">
      <p>上海市科学技术委员会</p>
      <p>Science and Technology Commission of Shanghai Municipality</p>
    </div>
    <div class="footer-item" style="display: block;">
      <p>
        <span style="display: inline-block;margin-right: 20px;">技术支持：上海教育软件发展有限公司</span>
        <span style="display: inline-block;">Technical Support：Shanghai Education Software Development Co., Ltd  021-25653284</span>
      </p>
    </div>
  </div>
  <div v-else class="m-bottom">
    <div class="m-footer-item">
      <p>主办单位: 上海市教育委员会 上海市科学技术委员会</p>
      <p>Organizers: Shanghai Municipal Education Commission  Science and Technology Commission of Shanghai Municipality</p>
      <p>技术支持：上海教育软件发展有限公司</p>
      <p>Technical Support：Shanghai Education Software Development Co., Ltd  021-25653284</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WebFooter'
}
</script>

<style scoped>
  .bottom {
    width:100%;
    min-width: 120rem;
    color: #ffffff;
    background-color: #3b4859;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 0.5rem;
  }
  .footer-item {
    display: inline-block;
    font-size: 1.2rem;
    color: #ffffff;
    text-align: center;
    font-weight: 400;
    margin-left: 10px;
    margin-right: 10px;
  }
  .m-bottom {
    width:100%;
    color: #ffffff;
    background-color: #3b4859;
  }
  .m-footer-item {
    font-size: 10px;
    text-align: center;
  }
  .m-footer-item {
    padding-top: 2px;
    line-height:1.2;
  }
  .m-footer-item p {
    margin-bottom: 0px;
    margin-top: 2px;
  }
</style>
